import { create } from "zustand"

interface OutOfOfficeDialogStore {
	isOpen: boolean
	setOpen: (isOpen: boolean) => void
}

/** The "Going out of office" dialog opens from settings, cmd+k and the avatar menu. */
export const useOutOfOfficeDialog = create<OutOfOfficeDialogStore>()((set) => ({
	isOpen: false,
	setOpen: (isOpen) => set({ isOpen }),
}))
